import { Card, CardContent, Stack } from '@mui/material';

import {
  CircularProgress,
  LinkItem,
  Typography,
  useAppLayoutContextConsumer,
} from '@occc-app/design-system';
import { MessagingCampaignDetailsFragment } from '@occc/graphql';
import {
  SendTestMessageSectionController,
  messagingCampaignDetailsFragmentToTestMessageTemplateInput,
} from '@occc/feat-messaging-test';

import { GeneralInfo } from './components/general-info/general-info.component';
import { MessageDetails } from './components/message-details/message-details.component';

type MessagingCampaignDetailsPageProps = {
  campaignData?: MessagingCampaignDetailsFragment | null;
  loading: boolean;
  breadcrumbLinks: LinkItem[];
};

export const MessagingCampaignDetailsPage = ({
  campaignData,
  loading,
  breadcrumbLinks,
}: MessagingCampaignDetailsPageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  if (loading && !campaignData) {
    return (
      <Card>
        <CardContent>
          <CircularProgress />
        </CardContent>
      </Card>
    );
  }

  if (!campaignData) {
    return (
      <Card>
        <CardContent>
          <Typography color='error'>No data. Something went wrong. Please try again.</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Stack spacing={1}>
      <GeneralInfo
        status={campaignData.status}
        scheduleAt={campaignData.scheduleAt}
        audience={campaignData.audience}
        channelsConfig={campaignData.channelsConfig}
      />
      <MessageDetails channelsConfig={campaignData.channelsConfig} />
      <SendTestMessageSectionController
        {...messagingCampaignDetailsFragmentToTestMessageTemplateInput(campaignData)}
      />
    </Stack>
  );
};
